jQuery(document).ready(function () {
	"use strict";
	var hero = document.querySelectorAll(".hero,.hero-home");
	if (hero.length==0) {
		document.body.classList.add('hero-none');
	}
});
